import React from 'react';
import styles from './Selector.module.css';

function useSelector(commands) {
  const select = (value) => commands.changeDataAttribute('donationValue', value);
  
  return ({
    eventHandlers: {
      select,
    },
  });
}

export default function Selector(props) {
  const { sharedStates, commands } = props;
  const { eventHandlers } = useSelector(commands);
  const { selected, text, value } = sharedStates;

  return (
    <button className={selected ? styles.selected : styles.btn} onClick={() => eventHandlers.select(value)}>
      <p className={selected ? styles.selectedText : styles.text}>{text}</p>
    </button>

  );
}
